import { createAction } from "@reduxjs/toolkit";

export const fetchProfilo = createAction("FETCH_PROFILO@osservatorio");

export const fetchProfiloSuccess = createAction("FETCH_PROFILO_SUCCESS@osservatorio");

export const inserisciProfilo = createAction("INSERISCI_PROFILO@osservatorio");

export const aggiornaProfilo = createAction("AGGIORNA_PROFILO@osservatorio");

export const inserimentoProfiloFailed = createAction("INSERIMENTO_PROFILO_FAILED@osservatorio");

export const fetchNotAuthorizedInfo = createAction("FETCH_NOT_AUTHORIZED_INFO@osservatorio");

export const fetchIstitutiScolastici = createAction("FETCH_ISTITUTI_SCOLASTICI@osservatorio");

export const fetchIstitutiScolasticiSuccess = createAction("FETCH_ISTITUTI_SCOLASTICI_SUCCESS@osservatorio");

export const fetchIstitutiScolasticiFailed = createAction("FETCH_ISTITUTI_SCOLASTICI_FAILED@osservatorio");

export const fetchIncarichi = createAction("FETCH_INCARICHI@osservatorio");

export const fetchIncarichiSuccess = createAction("FETCH_INCARICHI_SUCCESS@osservatorio");

export const fetchIncarichiFailed = createAction("FETCH_INCARICHI_FAILED@osservatorio");
